import script from "./model.vue?vue&type=script&setup=true&name=model3d&lang=js"
export * from "./model.vue?vue&type=script&setup=true&name=model3d&lang=js"

import "./model.vue?vue&type=style&index=0&id=ea7c936c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea7c936c"]])

export default __exports__